import React, { Component }  from "react";
import { Link } from "react-router-dom";
import formatLink from "../../utils/formatLink";
import axios from 'axios';
import Alert from "../../components/Alert/Alert";
import css from './FieldJobForms.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import _ from 'lodash';
import {connect} from "react-redux";
import Downshift from 'downshift';

const ServiceCallForm = class extends Component{
    source = axios.CancelToken.source();
    pickfields = [];
    reqFields = ['Root_Cause__c', 'Has_the_problem_been_fixed__c', 'Was_the_customer_home__c', 'Did_the_Inverter_Optimizer_need_to_be_R__c','Are_they_aware_of_the_situation__c'];

    componentDidMount(){
        window.scrollTo(0, 0);

        // Used to get picklist values for the below fields
        axios.get(
            '/sf/fieldjob/describeField/Estimated_time_needed_to_resolve_Service__c;What_type_of_tech_needs_to_be_sent_out__c;Trench_Inspection_Outcome__c',
            {
                cancelToken: this.source.token
            })
            .then((resPickFields) => {
                this.pickfields = resPickFields.data;
            })
            .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
            

        if(this.props.session.Case__c !== null && this.props.session.Case__r.ToDoListValues__c !== null){
            let toDoList = this.props.session.Case__r.ToDoListValues__c;
            this.setState({ToDoListArray: toDoList.split('%#')});
        }
    }

    state = {
        isEditing: false,
        shouldShowAlert: false,
        Id: this.props.fieldJob.Id,
        Root_Cause__c: this.props.fieldJob.Root_Cause__c,
        Has_the_problem_been_fixed__c: this.props.fieldJob.Has_the_problem_been_fixed__c,
        Anything_else_that_needs_to_be_done__c: this.props.fieldJob.Anything_else_that_needs_to_be_done__c,
        Estimated_time_needed_to_resolve_Service__c: this.props.fieldJob.Estimated_time_needed_to_resolve_Service__c,
        What_type_of_tech_needs_to_be_sent_out__c: this.props.fieldJob.What_type_of_tech_needs_to_be_sent_out__c,
        Has_the_Derate_been_completed__c: this.props.fieldJob.Has_the_Derate_been_completed__c,
        Why_was_the_derate_not_completed__c: this.props.fieldJob.Why_was_the_derate_not_completed__c,
        Has_the_new_subpanel_been_installed__c: this.props.fieldJob.Has_the_new_subpanel_been_installed__c,
        Has_the_subpanel_been_upgraded__c: this.props.fieldJob.Has_the_subpanel_been_upgraded__c,
        Has_the_SPAN_Panel_been_installed__c: this.props.fieldJob.Has_the_SPAN_Panel_been_installed__c,
        Was_the_transfer_switch_completed__c: this.props.fieldJob.Was_the_transfer_switch_completed__c,
        Has_the_EV_Charger_been_installed__c: this.props.fieldJob.Has_the_EV_Charger_been_installed__c,
        Has_the_220V_outlet_been_installed__c: this.props.fieldJob.Has_the_220V_outlet_been_installed__c,
        Has_breaker_relocation_been_completed__c: this.props.fieldJob.Has_breaker_relocation_been_completed__c,
        Has_other_electrical_work_been_completed__c: this.props.fieldJob.Has_other_electrical_work_been_completed__c,
        Was_the_customer_home__c: this.props.fieldJob.Was_the_customer_home__c,
        Any_other_notes_comments_from_the_cu__c:this.props.fieldJob.Any_other_notes_comments_from_the_cu__c,
        Are_they_aware_of_the_situation__c: this.props.fieldJob.Are_they_aware_of_the_situation__c,
        Did_the_Inverter_Optimizer_need_to_be_R__c: this.props.fieldJob.Did_the_Inverter_Optimizer_need_to_be_R__c,
        Case_RMA_number__c: this.props.fieldJob.Case_RMA_number__c,
        Service_Tech_Notes__c: this.props.fieldJob.Service_Tech_Notes__c,
        Has_the_trench_been_completed__c: this.props.fieldJob.Has_the_trench_been_completed__c,
        Trench_Inspection_Outcome__c: this.props.fieldJob.Trench_Inspection_Outcome__c,

        Remaining_Electrical_Work__c: this.props.session.Opportunity__r.Electrical_Work__c !== null ? this.props.session.Opportunity__r.Electrical_Work__r.Remaining_Electrical_Work__c : null,
        ToDoListArray: [],
        fieldTeam: [],
        assignedCrew: {},
        addidtionalTech: ''
    };

    saveFields = () => {
        const payload = {...this.state};
        this.setState({shouldShowAlert: false, alertMessage: ''});

        delete payload.isEditing;
        delete payload.alertMessage;
        delete payload.shouldShowAlert;
        delete payload.Remaining_Electrical_Work__c;
        delete payload.ToDoListArray;
        delete payload.fieldTeam;
        delete payload.assignedCrew;
        delete payload.addidtionalTech;

        let installCrew = '';

        if(this.state.addidtionalTech !== ''){
            installCrew = this.state.addidtionalTech;
            payload.Install_Crew__c = installCrew;
        }

        this.saveToDoListToCase();

        axios.put(
            '/sf/fieldjob/update',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.props.onSave(true);
                setTimeout(() => {
                    this.setState({isEditing: false});
                }, 1500);
            })
            .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
    };

    endJob = () => {
        const payload = {...this.state};

        if(this.validationCompleteCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});
            delete payload.isEditing;
            delete payload.alertMessage;
            delete payload.shouldShowAlert;
            delete payload.Remaining_Electrical_Work__c;
            delete payload.ToDoListArray;
            delete payload.fieldTeam;
            delete payload.assignedCrew;
            delete payload.addidtionalTech;

            payload.Clocked_End__c = moment().format(this.SF_DATE_TIME_FORMAT);
            payload.Status__c = 'Complete';
            payload.Completed_By__c = this.props.user.apiId;

            let installCrew = '';

            if(this.state.addidtionalTech !== ''){
                installCrew = this.state.addidtionalTech;
                payload.Install_Crew__c = installCrew;
            }

            this.saveToDoListToCase();

            axios.put(
                '/sf/fieldjob/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
        }
    };

    saveToDoListToCase = () =>{
        if(this.state.ToDoListArray.length !== 0 && this.props.session.Case__c !== null){
            let toDoList = '';

            this.state.ToDoListArray.forEach(item => {
                toDoList = toDoList + item + '%#'
            });

            let payload = {
                Id: this.props.session.Case__c,
                ToDoListValues__c: toDoList.slice(0, -2)
            }

            axios.put(
                '/sf/case/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update Case: \n', err));
        }
    }

    validationCompleteCheck = (payload) => {
        let valid = true;

        for (const key in payload) {
            if(this.reqFields.includes(key)){
                if(payload[key] === null) {
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out Required Fields (*) Before Ending Job'})
                    valid = false;
                    break;
                }
            }

            if(this.state.Has_the_problem_been_fixed__c === 'No' && (this.state.Anything_else_that_needs_to_be_done__c === null || this.state.Estimated_time_needed_to_resolve_Service__c === null || this.state.What_type_of_tech_needs_to_be_sent_out__c === null)){
                this.setState({shouldShowAlert: true, alertMessage: 'Please Fill In Additional Questions For Why Issue Is Not Resolved'});
                valid = false;
            }

            if(this.state.Was_the_customer_home__c === 'No' && this.state.Any_other_notes_comments_from_the_cu__c === null){
                this.setState({shouldShowAlert: true, alertMessage: 'Please Select If The Customer Had Any Comments'});
                valid = false;
            }

            if(this.state.Did_the_Inverter_Optimizer_need_to_be_R__c === 'Yes' && this.state.Case_RMA_number__c === null){
                this.setState({shouldShowAlert: true, alertMessage: 'Please enter the Case RMA Number'});
                valid = false;
            }
        }

        return valid;
    };

    // Handles the type of field needing to be entered and will list out their values
    // Also handles updating the state of the field being passed so additional logic 
    // can be ran and the form be built for saving the fields to salesforce.
    getInput = (inputType, field, fieldProps, fieldStateOptions) => {
        switch (inputType) {
            case 'yesNo':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option disabled value=""></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                );
            case 'picklist':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'multiPicklist':
                return(
                    <div className="pb-4">
                        <select onChange={(event) => this.setState({[field]: this.assignMultiple(event.target.selectedOptions)})} multiple>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'num':
                return(
                    <div className="pb-4">
                        <input
                            type="number"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'text':
                return(
                    <div className="pb-4">
                        <input
                            type="text"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'checkbox':
                return(
                    <div className="pb-4">
                        <input
                            type="checkbox"
                            defaultChecked={fieldProps ? fieldProps : false}
                            onChange={(event) => this.setState({[field]: !event.target.defaultChecked})}
                        />
                    </div>
                );
            case 'textarea':
                return(
                    <div className="pb-4">
                        <textarea
                            rows="5"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            default:
                return(
                    <div>
                        Not
                    </div>
                );
        };
    }

    assignMultiple = (value) => {
        const values = _.slice(value, [0], [value.length])
        const groupedValues = _.reduce(values, function(pickList, n) {
            return pickList + n.value + ';';
        }, '');

        return groupedValues;
    }

    saveToDo = (item) => {
        let tempArray = this.state.ToDoListArray;
        let index = tempArray.indexOf(item);

        if(index !== -1) {
            let newItem;

            if(item.includes('<s>')){
                newItem = item.replace(/<\/?s>/g, "");
            } else{
                newItem = '<s>' + item + '</s>';
            }

            tempArray[index] = newItem;

            this.setState({ToDoListArray: tempArray});
        } else {
            console.log('Item not found');
        }
    };

    updateFieldTeam = (selectedOptions) => {
        if(selectedOptions.length !== 0){
            let values = [];
            Array.from(selectedOptions).forEach(option => {
                values.push(option.value);
            });

            this.setState({fieldTeam: values});
        }
    };

    render(){
      return (
        <div className={css.FieldJobForms}>
            <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage} <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({shouldShowAlert: false, alertMessage: ''})} /></Alert>
            
            {/* Header of Field Job Form and includes buttons to End Job and Save */}
            <div className="d-flex justify-content-between mt-5 mb-4">
                <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                    <button className="btn btn-outline" type="button">Back</button>
                </Link>

                <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                    <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                    <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                </div>

                <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                    <a
                        href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button className="btn btn-outline">Upload</button>
                    </a>
                    <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                </div>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
            </div>
            {/* End of Header */}

            {
                this.state.isEditing ?

                // Render when editing
                <div className="text-white">
                    <h2 className="pt-4">Service Call</h2>

                    <div className="py-2">
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Add Additional Tech On Site:</label>
                        <Downshift 
                            onChange={selection => this.setState({addidtionalTech: selection.id})}
                            itemToString={item => (item ? item.value : '')}
                        >
                            {({
                                getInputProps,
                                getItemProps,
                                getMenuProps,
                                isOpen,
                                inputValue,
                                highlightedIndex,
                                selectedItem
                            }) => (
                            <div>
                                <div className="w-72 flex flex-col gap-1">
                                    <div className="flex bg-white gap-0.5">
                                        <input className='form-control' placeholder="Type Tech's Name" {...getInputProps()} />
                                    </div>
                                </div>
                                <ul className="list-group" {...getMenuProps()}>
                                    {
                                        isOpen ? 
                                        this.props.activeFieldPersonnel.filter(item => !inputValue || (item.value).toLowerCase().includes(inputValue) || item.value.includes(inputValue))
                                            .map((item, index) => (
                                            <li className="list-group-item" {...getItemProps({key: item.value, index, item,
                                                style: {
                                                    backgroundColor:
                                                    highlightedIndex === index ? 'lightgray' : 'black',
                                                    fontWeight: selectedItem === item ? 'bold' : 'normal',
                                                },
                                                })}
                                            >
                                                {item.value}
                                            </li>
                                        ))
                                        : null
                                    }
                                </ul>
                            </div>
                            )}
                        </Downshift>
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Cause of issue? *</label>
                        {this.getInput('textarea', 'Root_Cause__c', this.state.Root_Cause__c)}
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Is the issue you were sent for 100% resolved? *</label>
                        {this.getInput('yesNo', 'Has_the_problem_been_fixed__c', this.state.Has_the_problem_been_fixed__c)}
                    </div>
                    {/* Conditional Rendering for Has_the_problem_been_fixed__c */}
                    <div className={this.state.Has_the_problem_been_fixed__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Anything else that needs to be done? *</label>
                            {this.getInput('yesNo', 'Anything_else_that_needs_to_be_done__c', this.state.Anything_else_that_needs_to_be_done__c)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Estimated time needed to resolve Service Issue. *</label>
                            {this.getInput('picklist', 'Estimated_time_needed_to_resolve_Service__c', this.state.Estimated_time_needed_to_resolve_Service__c, this.pickfields.Estimated_time_needed_to_resolve_Service__c.picklistValues)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What type of tech needs to be sent out? *</label>
                            {this.getInput('multiPicklist', 'What_type_of_tech_needs_to_be_sent_out__c', this.state.What_type_of_tech_needs_to_be_sent_out__c, this.pickfields.What_type_of_tech_needs_to_be_sent_out__c.picklistValues)}
                        </div>
                    </div>
                    {/* End of Has_the_problem_been_fixed__c */}

                    {/* Conditional Rendering for Remaining_Electrical_Work__c */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Derate') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the Derate been completed?</label>
                            {this.getInput('yesNo', 'Has_the_Derate_been_completed__c', this.state.Has_the_Derate_been_completed__c)}
                        </div>
                        <div className={this.state.Has_the_Derate_been_completed__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Why was the derate not completed?</label>
                                {this.getInput('text', 'Why_was_the_derate_not_completed__c', this.state.Why_was_the_derate_not_completed__c)}
                            </div>
                        </div>
                    </div>
                    {/* End Of Remaining_Electrical_Work__c */}

                    {/* Conditional Rendering for New Subpanel */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('New Subpanel') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the new subpanel been installed?</label>
                            {this.getInput('yesNo', 'Has_the_new_subpanel_been_installed__c', this.state.Has_the_new_subpanel_been_installed__c)}
                        </div>
                    </div>
                    {/* End Of New Subpanel */}

                    {/* Conditional Rendering for Subpanel Upgrade */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Subpanel Upgrade') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the subpanel been upgraded?</label>
                            {this.getInput('yesNo', 'Has_the_subpanel_been_upgraded__c', this.state.Has_the_subpanel_been_upgraded__c)}
                        </div>
                    </div>
                    {/* End Of Subpanel Upgrade */}

                    {/* Conditional Rendering for SPAN Panel */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('SPAN Panel') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the SPAN Panel been installed?</label>
                            {this.getInput('yesNo', 'Has_the_SPAN_Panel_been_installed__c', this.state.Has_the_SPAN_Panel_been_installed__c)}
                        </div>
                    </div>
                    {/* End Of SPAN Panel */}

                    {/* Conditional Rendering for Transfer Switch */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Transfer Switch') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Was the transfer switch completed?</label>
                            {this.getInput('yesNo', 'Was_the_transfer_switch_completed__c', this.state.Was_the_transfer_switch_completed__c)}
                        </div>
                    </div>
                    {/* End Of Transfer Switch */}

                    {/* Conditional Rendering for EV Charger */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('EV Charger') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the EV Charger been installed?</label>
                            {this.getInput('yesNo', 'Has_the_EV_Charger_been_installed__c', this.state.Has_the_EV_Charger_been_installed__c)}
                        </div>
                    </div>
                    {/* End Of EV Charger */}

                    {/* Conditional Rendering for 220V Outlet */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('220V Outlet') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the 220V outlet been installed?</label>
                            {this.getInput('yesNo', 'Has_the_220V_outlet_been_installed__c', this.state.Has_the_220V_outlet_been_installed__c)}
                        </div>
                    </div>
                    {/* End Of 220V Outlet */}

                    {/* Conditional Rendering for Relocating Breakers */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Relocating Breakers') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has breaker relocation been completed?</label>
                            {this.getInput('yesNo', 'Has_breaker_relocation_been_completed__c', this.state.Has_breaker_relocation_been_completed__c)}
                        </div>
                    </div>
                    {/* End Of Relocating Breakers */}

                    {/* Conditional Rendering for Other */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Other') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has other electrical work been completed?</label>
                            {this.getInput('yesNo', 'Has_other_electrical_work_been_completed__c', this.state.Has_other_electrical_work_been_completed__c)}
                        </div>
                    </div>
                    {/* End Of Other */}

                    {/* Conditional Rendering for Trench */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Trench') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the trench been completed?</label>
                            {this.getInput('yesNo', 'Has_the_trench_been_completed__c', this.state.Has_the_trench_been_completed__c)}
                        </div>
                    </div>
                    {/* End Of Trench */}

                    {/* Conditional Rendering for Trench Inspection */}
                    <div className={this.state.Has_the_trench_been_completed__c === 'Yes' || (this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Trench Inspection')) ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Trench inspection outcome</label>
                            {this.getInput('picklist', 'Trench_Inspection_Outcome__c', this.state.Trench_Inspection_Outcome__c, this.pickfields.Trench_Inspection_Outcome__c.picklistValues)}
                        </div>
                    </div>
                    {/* End Of Trench Inspection */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Was the customer home? *</label>
                        {this.getInput('yesNo', 'Was_the_customer_home__c', this.state.Was_the_customer_home__c)}
                    </div>
                    {/* Conditional Rendering for Was_the_customer_home__c */}
                    <div className={this.state.Was_the_customer_home__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Did the customer have any comments? *</label>
                            {this.getInput('textarea', 'Any_other_notes_comments_from_the_cu__c', this.state.Any_other_notes_comments_from_the_cu__c)}
                        </div>
                    </div>
                    {/* End of Was_the_customer_home__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Are they aware of the situation? *</label>
                        {this.getInput('yesNo', 'Are_they_aware_of_the_situation__c', this.state.Are_they_aware_of_the_situation__c)}
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Inverter/Optimizer need to be RMAed? *</label>
                        {this.getInput('yesNo', 'Did_the_Inverter_Optimizer_need_to_be_R__c', this.state.Did_the_Inverter_Optimizer_need_to_be_R__c)}
                    </div>
                    {/* Conditional Rendering for Did_the_Inverter_Optimizer_need_to_be_R__c */}
                    <div className={this.state.Did_the_Inverter_Optimizer_need_to_be_R__c === 'Yes' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Case/RMA number: *</label>
                            {this.getInput('text', 'Case_RMA_number__c', this.state.Case_RMA_number__c)}
                        </div>
                    </div>
                    {/* End of Did_the_Inverter_Optimizer_need_to_be_R__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Service Tech Notes:</label>
                        {this.getInput('textarea', 'Service_Tech_Notes__c', this.state.Service_Tech_Notes__c)}
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">To Do List:</label>
                        { 
                            this.state.ToDoListArray.length !== 0 ?
                            this.state.ToDoListArray.map((item, index) => (
                                <div className="col-sm-7 col-12 py-2">    
                                    <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveToDo(item)}>Done</button><li className="d-inline px-4" key={index} dangerouslySetInnerHTML={{__html: item}}></li>
                                </div>))
                            :
                            ''
                        }
                    </div>
                </div>

                :

                // RENDER WHEN NOT EDITING
                // 

                <div className="text-white">
                    <h2 className="pt-4">Service Call</h2>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Cause of issue? *</label>
                        <div className="col-sm-7 col-12">{this.props.fieldJob.Root_Cause__c ? this.props.fieldJob.Root_Cause__c : '---'}</div>
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Is the issue you were sent for 100% resolved? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_problem_been_fixed__c ? this.props.fieldJob.Has_the_problem_been_fixed__c : '---'}</div>
                    </div>
                    {/* Conditional Rendering for Has_the_problem_been_fixed__c */}
                    <div className={this.props.fieldJob.Has_the_problem_been_fixed__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Anything else that needs to be done? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Anything_else_that_needs_to_be_done__c ? this.props.fieldJob.Anything_else_that_needs_to_be_done__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Estimated time needed to resolve Service Issue. *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Estimated_time_needed_to_resolve_Service__c ? this.props.fieldJob.Estimated_time_needed_to_resolve_Service__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What type of tech needs to be sent out? *</label>
                            <div className="col-sm-7 col-12">{this.props.fieldJob.What_type_of_tech_needs_to_be_sent_out__c ? this.props.fieldJob.What_type_of_tech_needs_to_be_sent_out__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Has_the_problem_been_fixed__c */}

                    {/* Conditional Rendering for Remaining_Electrical_Work__c */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Derate') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the Derate been completed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_Derate_been_completed__c ? this.props.fieldJob.Has_the_Derate_been_completed__c : '---'}</div>
                        </div>
                        <div className={this.props.fieldJob.Has_the_Derate_been_completed__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Why was the derate not completed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_was_the_derate_not_completed__c ? this.props.fieldJob.Why_was_the_derate_not_completed__c : '---'}</div>
                            </div>
                        </div>
                    </div>
                    {/* End of Remaining_Electrical_Work__c */}

                    {/* Conditional Rendering for New Subpanel */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('New Subpanel') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the new subpanel been installed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_new_subpanel_been_installed__c ? this.props.fieldJob.Has_the_new_subpanel_been_installed__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of New Subpanel */}

                    {/* Conditional Rendering for Subpanel Upgrade */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Subpanel Upgrade') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the subpanel been upgraded?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_subpanel_been_upgraded__c ? this.props.fieldJob.Has_the_subpanel_been_upgraded__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Subpanel Upgrade */}

                    {/* Conditional Rendering for SPAN Panel */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('SPAN Panel') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the SPAN Panel been installed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_SPAN_Panel_been_installed__c ? this.props.fieldJob.Has_the_SPAN_Panel_been_installed__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of SPAN Panel */}

                    {/* Conditional Rendering for Transfer Switch */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Transfer Switch') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Was the transfer switch completed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Was_the_transfer_switch_completed__c ? this.props.fieldJob.Was_the_transfer_switch_completed__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Transfer Switch */}

                    {/* Conditional Rendering for EV Charger */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('EV Charger') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the EV Charger been installed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_EV_Charger_been_installed__c ? this.props.fieldJob.Has_the_EV_Charger_been_installed__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of EV Charger */}

                    {/* Conditional Rendering for 220V Outlet */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('220V Outlet') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the 220V outlet been installed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_220V_outlet_been_installed__c ? this.props.fieldJob.Has_the_220V_outlet_been_installed__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of 220V Outlet */}

                    {/* Conditional Rendering for Relocating Breakers */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Relocating Breakers') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has breaker relocation been completed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_breaker_relocation_been_completed__c ? this.props.fieldJob.Has_breaker_relocation_been_completed__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Relocating Breakers */}

                    {/* Conditional Rendering for Other */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Other') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has other electrical work been completed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_other_electrical_work_been_completed__c ? this.props.fieldJob.Has_other_electrical_work_been_completed__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Other */}

                    {/* Conditional Rendering for Trench */}
                    <div className={this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Trench') ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Has the trench been completed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_trench_been_completed__c ? this.props.fieldJob.Has_the_trench_been_completed__c : '---'}</div>
                        </div>
                    </div>
                    {/* End Of Trench */}

                    {/* Conditional Rendering for Trench Inspection */}
                    <div className={this.props.fieldJob.Has_the_trench_been_completed__c === 'Yes' || (this.state.Remaining_Electrical_Work__c !== null && this.state.Remaining_Electrical_Work__c.includes('Trench Inspection')) ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Trench inspection outcome</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Trench_Inspection_Outcome__c ? this.props.fieldJob.Trench_Inspection_Outcome__c : '---'}</div>
                        </div>
                    </div>
                    {/* End Of Trench Inspection */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Was the customer home? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Was_the_customer_home__c ? this.props.fieldJob.Was_the_customer_home__c : '---'}</div>
                    </div>
                    {/* Conditional Rendering for Was_the_customer_home__c */}
                    <div className={this.props.fieldJob.Was_the_customer_home__c === 'No' ? 'mt-0' : 'd-none'}> 
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Did the customer have any comments? *</label>
                            <div className="col-sm-7 col-12">{this.props.fieldJob.Any_other_notes_comments_from_the_cu__c ? this.props.fieldJob.Any_other_notes_comments_from_the_cu__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Was_the_customer_home__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Are they aware of the situation? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Are_they_aware_of_the_situation__c ? this.props.fieldJob.Are_they_aware_of_the_situation__c : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Inverter/Optimizer need to be RMAed? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Did_the_Inverter_Optimizer_need_to_be_R__c ? this.props.fieldJob.Did_the_Inverter_Optimizer_need_to_be_R__c : '---'}</div>
                    </div>
                    {/* Conditional Rendering for Did_the_Inverter_Optimizer_need_to_be_R__c */}
                    <div className={this.state.Did_the_Inverter_Optimizer_need_to_be_R__c === 'Yes' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Case/RMA number: *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Case_RMA_number__c ? this.props.fieldJob.Case_RMA_number__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Did_the_Inverter_Optimizer_need_to_be_R__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Service Tech Notes:</label>
                        <div className="col-sm-7 col-12">{this.props.fieldJob.Service_Tech_Notes__c ? this.props.fieldJob.Service_Tech_Notes__c : '---'}</div>
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">To Do List:</label>
                        { 
                            this.state.ToDoListArray.length !== 0 ?
                            this.state.ToDoListArray.map((item, index) => (
                                <div className="col-sm-7 col-12 py-2">    
                                    <li className="px-4" key={index} dangerouslySetInnerHTML={{__html: item}}></li>
                                </div>))
                            :
                            ''
                        }
                    </div>
                </div>
            }

            {/* Footer of Field Job Form that includs the buttons for Endind and Saving Job */}
            <div className="mt-5 mb-4">
                <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                    <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
                </div>

                <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                    <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
                </div>
                <div className="d-flex justify-content-between mt-3">
                    {/* the ternary expression prevents user from clicking the link before `schedulableId` has been fetched: */}
                    <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                        <button className="btn btn-outline" type="button">Back</button>
                    </Link>

                    <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                        <button className="btn btn-outline" type="button" onClick={() => this.setState({isEditing: false})}>Cancel</button>
                        <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                    </div>

                    <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                        <a
                            href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="btn btn-outline">Upload</button>
                        </a>
                        <button className="btn btn-outline ml-2" type="button" onClick={() => this.setState({isEditing: true})}>Edit</button>
                    </div>

                </div>
            </div>

        </div>
    )};
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(ServiceCallForm);